import Metrics from './Metrics'
import plugin from './plugin'

Metrics.plugin = plugin
export default Metrics
export const init = Metrics.init
export {
  plugin,
}
